ui-cms-standard-teaser-group {
  display: block;

  .teaser-group:not(:first-child) {
    margin-top: 24px;
  }

  ui-cms-standard-teaser {
    margin-top: 24px;

    @include breakpoint($small) {
      /* stylelint-disable-next-line function-no-unknown */
      margin-top: gutter() * 2;
    }

    &:first-child {
      margin-top: 0;
    }
  }

  .teaser-group {
    position: relative;

    @include breakpoint($small) {
      &--2,
      &--4 {
        /* stylelint-disable-next-line function-no-unknown */
        margin-left: -1 * gutter();
        /* stylelint-disable-next-line function-no-unknown */
        margin-right: -1 * gutter();

        ui-cms-standard-teaser {
          @include span(6 of 12);

          &:nth-child(2) {
            margin-top: 0;
          }
        }
      }
    }

    @include breakpoint($medium) {
      display: flex;
      flex-wrap: wrap;

      &--3 {
        /* stylelint-disable-next-line function-no-unknown */
        margin-left: -1 * gutter();
        /* stylelint-disable-next-line function-no-unknown */
        margin-right: -1 * gutter();

        ui-cms-standard-teaser {
          @include span(4 of 12);

          &:nth-child(2),
          &:nth-child(3) {
            margin-top: 0;
          }
        }
      }

      &--4 {
        ui-cms-standard-teaser {
          @include span(3 of 12);

          &:nth-child(3),
          &:nth-child(4) {
            margin-top: 0;
          }
        }
      }

      &--2 {
        &.column-distribution--4_8 ui-cms-standard-teaser {
          --component-teaser-padding: 16px;

          &:nth-of-type(odd) {
            @include span(4 of 12);
          }

          &:nth-of-type(even) {
            @include span(8 of 12);
          }
        }

        &.column-distribution--8_4 ui-cms-standard-teaser {
          --component-teaser-padding: 16px;

          &:nth-of-type(odd) {
            @include span(8 of 12);
          }

          &:nth-of-type(even) {
            @include span(4 of 12);
          }
        }
      }
    }
  }
}
